import { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IconButton } from '@components/base';
import { CollectionType } from '@enums/CollectionType';
import { FilterGroup } from '@models/SearchFilter';
import SaveCollectionDialog from '@modules/layouts/collections/components/SaveCollectionDialog';
import useSearchAndFilter from '@modules/layouts/hooks/useSearchAndFilter';
import { getFilterWithProvider } from '@utils/filterUtils';
import { SaveDialogContext } from '@utils/saveUtils';
import { buildQueryCollectionData } from '@utils/searchUtils';

export type SearchToolbarMenuProps = {
  disableSaveSearch?: boolean;
  filter: FilterGroup;
};

const SaveAsCollectionButton: FC<SearchToolbarMenuProps> = ({ disableSaveSearch, filter }) => {
  const { t } = useTranslation();

  const {
    filterCount,
    filterDefLoad: { data: filterDefs },
    provider,
    searchQuery,
    searchQuery: { queryText },
  } = useSearchAndFilter();

  const [saveAsCollectionDialogOpen, setSaveAsCollectionDialogOpen] = useState(false);

  const hasQueryValues = filterCount > 0 || queryText || provider;

  const fullFilter =
    provider && filterDefs ? getFilterWithProvider(filterDefs, filter, provider) : filter;

  return disableSaveSearch ? null : (
    <Fragment>
      <IconButton
        disabled={!hasQueryValues}
        icon='save'
        onClick={() => setSaveAsCollectionDialogOpen(true)}
        title={t('saveSearchAsCollection')}
      />

      {saveAsCollectionDialogOpen && (
        <SaveCollectionDialog
          collection={{
            data: buildQueryCollectionData({ ...searchQuery, filter: fullFilter }),
            type: CollectionType.QUERY,
          }}
          hideTypeField
          onClose={() => setSaveAsCollectionDialogOpen(false)}
          saveContext={SaveDialogContext.CREATE}
        />
      )}
    </Fragment>
  );
};

export default SaveAsCollectionButton;
